// src/components/OpcaoCard.js
import React from 'react';
import { getLocalDescription, formatarData } from '../utils/helpers';

export const OpcaoCard = ({ opcao, handleSelecionarOpcao, todasEscolhas }) => {
    const { invalido, local_nome, tipo, turno, data, capacidade, cpa_nome } = opcao;

    // CORREÇÃO: Nova regra para ocultar o "invalido" no card se for PJ e a invalidez for regra interna (capacidade/turno)
    let displayInvalido = invalido;
    let isDisabled = !!invalido;

    if (tipo === 'PJ') {
        // Verifica se a invalidez é devido à capacidade esgotada ou regra de dia/turno
        const isInternalRule = invalido && (
            invalido === "Vagas PJ esgotadas." ||
            invalido.startsWith("PJ (Dom-Qui)") ||
            invalido.startsWith("PJ (Sex)") ||
            invalido.startsWith("PJ (Sáb")
        );

        if (isInternalRule) {
            // Se for uma regra interna, apenas desabilita, mas não mostra o erro interno
            // EXCEÇÃO: Se for 'Vagas PJ esgotadas', mostramos a mensagem de vagas esgotadas, que é relevante.
            if (invalido === "Vagas PJ esgotadas.") {
                displayInvalido = invalido;
            } else {
                displayInvalido = null;
            }
        } else if (invalido) {
            // Se for outro erro (ex: já estagiou, já escolheu este dia), mostra
            displayInvalido = invalido;
        }
    } else {
        // Para PCO, mantém a lógica anterior (mostrar se invalido)
        displayInvalido = invalido;
    }

    // *** INÍCIO DA MUDANÇA ***

    // Contagem de vagas E Nomes (usando o estado 'todasEscolhas')
    const escolhasParaEstaVaga = todasEscolhas.filter(
        e => !e.opcao_impossibilidade && e.data_estagio_id === opcao.id
    );
    const vagasOcupadas = escolhasParaEstaVaga.length;
    const isVagaCheia = vagasOcupadas >= capacidade;

    // Pega os nomes dos cadetes que escolheram
    let nomesCadetes = [];
    if (isVagaCheia) {
         nomesCadetes = escolhasParaEstaVaga.map(e => e.cadete_nome).sort();
    }
    
    // *** FIM DA MUDANÇA ***

    // Cores: PCO (Azul/Ciano) e PJ (Verde Claro)
    const baseClass = tipo === 'PCO'
      ? 'border-sky-400 hover:border-sky-600'
      : 'border-green-400 hover:border-green-600';

    const headerClass = tipo === 'PCO'
      ? 'bg-sky-100 text-sky-800'
      : 'bg-green-100 text-green-800';

    const vagaStatusColor = isVagaCheia ? 'text-red-500' : 'text-green-600';

    const localDescription = getLocalDescription(local_nome);

    return (
      <div
        // MUDANÇA: Adiciona nomes ao 'title' (tooltip) se estiver cheia
        title={isDisabled ? (invalido) : (isVagaCheia ? `Vaga(s) preenchida(s) por: ${nomesCadetes.join(', ')}` : `Clique para escolher ${local_nome} - ${formatarData(data)}`)}
        className={`w-full rounded-xl shadow-md p-3 transition-all transform hover:scale-[1.02] ${
          isDisabled
            ? 'bg-gray-100 text-gray-400 opacity-70 cursor-not-allowed'
            : `bg-white hover:shadow-xl cursor-pointer border-2 ${baseClass}`
        }`}
        onClick={() => !isDisabled && handleSelecionarOpcao(opcao)}
      >
        <div className="flex justify-between items-center mb-1">
          <h4 className={`text-sm font-bold truncate ${isDisabled ? 'text-gray-500' : 'text-gray-800'}`}>{local_nome}</h4>
          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${headerClass}`}>
            {tipo}
          </span>
        </div>

        {/* Bloco de Detalhes da Localização (Apenas PCO) */}
        {tipo === 'PCO' && (
            <p className="text-[10px] text-gray-600 mb-2 italic border-b pb-2">
                Área: {localDescription}
            </p>
        )}
        {/* Bloco de Detalhes do Estágio */}
        <div className="mt-2 text-xs grid grid-cols-2 gap-1 pt-1">
          <p className="text-gray-600 col-span-2"><strong>Dia:</strong> {formatarData(data)}</p>

          {/* PJ Válido ou PCO: mostra turno */}
          {(tipo === 'PCO' || (tipo === 'PJ' && !isDisabled)) && (
            <p className="text-gray-600 col-span-2"><strong>Turno:</strong> {turno}</p>
          )}

          {/* --- MUDANÇA: Mostrar nome se a vaga PCO estiver preenchida --- */}
          {isVagaCheia && tipo === 'PCO' && nomesCadetes.length > 0 ? (
            <div className="col-span-2 text-xs pt-1">
                <p className="font-semibold text-red-500">Vaga preenchida por:</p>
                <p className="font-bold text-gray-700 truncate">{nomesCadetes[0]}</p>
            </div>
          ) : (
            // Se for PJ ou se a vaga PCO não estiver cheia, mostra a contagem normal
            <p className="text-gray-600 font-semibold col-span-2">
              Vagas: <span className={`font-bold ${vagaStatusColor}`}>{vagasOcupadas}</span> / {capacidade}
              {/* Adiciona "(Esgotado)" para PJ */}
              {isVagaCheia && tipo === 'PJ' && ' (Esgotado)'}
            </p>
          )}
          {/* --- FIM DA MUDANÇA --- */}
        </div>

        {/* O 'displayInvalido' ainda mostra erros como "Você já estagiou aqui" */}
        {displayInvalido && (
            <p className="text-[10px] text-red-500 mt-2 italic font-medium truncate">{displayInvalido}</p>
        )}
      </div>
    );
};